import { render, staticRenderFns } from "./SettingsAlarms.vue?vue&type=template&id=d3090b4a"
import script from "./SettingsAlarms.vue?vue&type=script&lang=js"
export * from "./SettingsAlarms.vue?vue&type=script&lang=js"
import style0 from "./SettingsAlarms.vue?vue&type=style&index=0&id=d3090b4a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports